import React from 'react';
import "./index.scss";

import { assetImg } from "@/modules/moduleImporter";
import { hideLoadingScreen } from "@/modules/loading";

import "@/assets/fonts/sl-fonts/style.css";
import "@/index.scss";
import "@/scrollbars.scss";

interface IProps {
	match?: any; //from React Router

	errorType: string;
	errorMessage: string;
}

export default class ErrorPage extends React.PureComponent<IProps> {
	render() {
		window.setTimeout(() => {
			hideLoadingScreen();
		}, 1000);
		
		let errorType = this.props.errorType;
		
		if (!errorType)
			errorType = /(?:[^.]+)/.exec(this.props.match.params.errorname)[0];
		
		return (
			<div id="errorPage"
				className={"error " +
					(errorType !== "lostauth" && errorType !== "idle" ? "box" : "")
				}>
				<div className="image">
				{
					errorType === "idle" ?
						assetImg("errors", "idle") :
					errorType === "lostauth" ?
						assetImg("errors", "lostauth.jpg") :
					errorType === "400" ?
						assetImg("errors", "400") :
					errorType === "403" ?
						assetImg("errors", "403") :
					errorType === "500" ?
						assetImg("errors", "500") :
					//404
						assetImg("errors", "404")
				}
				</div>
				<div className="message">{ this.props.errorMessage }</div>
			</div>
		);
	}
}
